module.exports = __webpack_public_path__ + "static/media/udemy-certificate.6e8b6adf.PNG";